import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { DataExtractionService, DocumentService } from '@app/shared/services';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { FilePreviewSetupComponent } from './file-preview-setup/file-preview-setup.component';
import { AddSubfolderComponent } from '@app/modules/vault/components/dialogs/add-subfolder/add-subfolder.component';
import { MatDialog } from '@angular/material/dialog';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { FormPreviewSetupComponent } from './form-preview-setup/form-preview-setup.component';
import { RootStoreState } from '@app/root-store';
import { Store } from '@ngrx/store';
import { AnimationOptions } from 'ngx-lottie';
import { InboxSettingsService } from '@app/shared/services/settings/inbox-settings/inbox-settings.service';
import { environment } from '@env/environment';
//
import { fetchAuthSession, fetchUserAttributes } from '@aws-amplify/auth';
import { SharedDocViewerDialogComponent } from '@app/shared/component/shared-doc-viewer-dialog/shared-doc-viewer-dialog.component';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'set-up-form-creation',
  templateUrl: './set-up-form-creation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetUpFormCreationComponent implements OnInit, OnDestroy {
  @ViewChildren(FilePreviewSetupComponent) fileExtensionComponentchild: QueryList<FilePreviewSetupComponent>;
  @Output() individualLocationNextStep: EventEmitter<any> = new EventEmitter();
  @ViewChild(FormPreviewSetupComponent) childComponent: FormPreviewSetupComponent;
  @Input() data;

  urlLinks = [];
  screenWidth: number;
  todo = ['Get to work', 'Pick up groceries', 'Go home', 'Fall asleep'];

  done = ['Get up', 'Brush teeth', 'Take a shower', 'Check e-mail', 'Walk dog'];

  getAnimationOptions: AnimationOptions = {
    path: 'assets/lottie/upload-running.json',
  };

  resizeObservable$: Observable<Event>;
  subscription: Subscription = new Subscription();
  steps = [{}, {}];
  Form1 = [];
  files = [];
  hideAttachmentAvailableSection = false;
  loadingItems = [{ id: 1 }, { id: 2 }];
  folderList = [];
  JsonDataExtractedData;
  is_file_loading = false;
  showStepTwo = false;
  FileUploadedLimit = 30;
  enableContinue = false;
  currentFormId;
  loginStateObject: any;
  currentuserId;
  securityStateObject;
  selectDOntAdd = false;
  transaction_status = 'Create Form';
  searchText = '';
  selectedFiles = 0;
  currentStep = 0;
  loadOnce = true;
  reminderList = [];
  dragged_data;
  attachedFiles = [];
  attachedFiles_loading = true;

  // Worker references for proper cleanup
  private activeWorkers: Map<string, Worker> = new Map();

  constructor(
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private _inboxService: InboxSettingsService,
    private store$: Store<RootStoreState.State>,
    private loginService: LoginStoreEffects,
    private documentService: DocumentService,
    private toastr: ToastrService,
    private _dataExtractionService: DataExtractionService
  ) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();

    // Terminate all active workers
    this.activeWorkers.forEach((worker, id) => {
      worker.terminate();
    });
    this.activeWorkers.clear();
  }

  getUrl(file, index, fileName) {
    let link = file.link;
    this.dialog.open(SharedDocViewerDialogComponent, {
      width: '100%',
      height: '100%',
      panelClass: 'shared-doc-view-dialog',
      data: {
        index: index,
        file: file,
        urlLink: link,
      },
    });
  }
  onInputChange(searchValue: string) {
    this.searchText = searchValue;
    this.cd.detectChanges();
  }
  getAllFIle() {
    this.getInboxData(this.currentuserId);
  }

  ngOnInit(): void {
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        this.loginStateObject = { ...state.data };

        if (state?.data) {
          this.currentuserId = state.data.id;
          if (this.loadOnce) {
            this.getInboxData(this.currentuserId);
            this.loadOnce = false;
          }
        }
      })
    );
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );
    this.currentFormId = this.data.vault_user_form_id;
    this.subscription.add(
      this.documentService.getReminderList(this.data.user_id, this.currentFormId, true).subscribe((res) => {
        if (res) {
          this.reminderList = res.filter((x) => x.origin == 'upload');
          this.selectDOntAdd = this.reminderList[0].onboarding_status == 'donotadd' ? true : false;
          this.getAttcahedFileWithReminder();
          this.cd.detectChanges();
        }
      })
    );
  }
  getAttcahedFileWithReminder() {
    let vault_user_form_reminder_id = this.reminderList[this.currentStep].id;
    this.attachedFiles = [];
    this.attachedFiles_loading = true;
    this.cd.detectChanges();
    this.subscription.add(
      this._inboxService.attachFileToReminder(vault_user_form_reminder_id).subscribe((res) => {
        this.attachedFiles_loading = false;
        this.attachedFiles = [];
        if (res) {
          res?.forEach((element) => {
            this.attachedFiles.push({
              ...element,
              status: 'Done',
              selected: false,
            });
          });
        }

        this.cd.detectChanges();
      })
    );
  }

  dropleave(ev) {}

  allowDrop(ev) {
    ev.preventDefault();
  }

  getInboxData(userId: number) {
    this.subscription.add(
      this._inboxService.getInboxData(userId).subscribe(
        (result: any) => {
          // set file list
          this.files = [];
          if (result?.data) {
            result?.data.forEach((element) => {
              this.files.push({
                ...element,
                status: 'Done',
                selected: false,
                showButton: false,
              });
            });
            this.selectedFiles = this.files.filter((x) => x.selected).length;
          }

          if (this.files.length == 0) {
            this.hideAttachmentAvailableSection = true;
          }
          this.is_file_loading = false;
          this.cd.detectChanges();
          setTimeout(() => {
            // this will make the execution after the above boolean has changed
            this.fileExtensionComponentchild.forEach((FileExtensionComponent, index) => {
              FileExtensionComponent.StartPreviewImage();
            });
          }, 0);
        },
        (error: any) => {}
      )
    );
  }
  uploadFile(event) {
    const items = event.target.files;
    Object.keys(items).forEach((key, index) => {
      this.uploadDocument(items[key], items[key]?.name);
    });
  }
  uploadDocument(element, name) {
    // this.fileList.push({
    //   name: element.name,
    //   status: 'running',
    //   size: element.size,
    //   type: element.type,
    // });
    const data = {
      user_id: this.loginStateObject.id,
      name: element.name,
      file_name_without_extesion: element.name.split('.').slice(0, -1).length == 0 ? element.name : element.name.split('.').slice(0, -1).join('.'),
      display_file_name: element.name,
      size: element.size,
      vault_user_form_id: this.currentFormId,
      type: element.type,
    };
    this.CreteCreatePresignedUrl(element.name, data, element, this.attachedFiles.length + 1);
  }
  async CreteCreatePresignedUrl(fileName, data, file, index) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        const workerId = `presign-${Date.now()}-${Math.random()}`;
        const worker = new Worker(new URL('./upload-presign-url.worker', import.meta.url), { type: 'module' });
        this.activeWorkers.set(workerId, worker);

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        data.url = `${environment.apiUrl}/api/vault/form-upload-file`;
        worker.onmessage = async ({ data }) => {
          //return security key generated by worker process
          resolve(data);
          let res = data.data;

          // Terminate and cleanup worker
          worker.terminate();
          this.activeWorkers.delete(workerId);

          if (res['uploadLimitExceeded']) {
            this.toastr.error(`All the storage space in your Vault has been used`);

            this.cd.detectChanges();
            return;
          } else if (res['limit_exceeded']) {
            // this.fileList[index].status = 'fail';
            // this.completedCount = this.completedCount + 1;
            this.cd.detectChanges();
            return;
          } else {
            this.attachedFiles.push({
              status: 'Uploading',
              file_name_without_extesion: fileName.split('.').slice(0, -1).length == 0 ? fileName : fileName.split('.').slice(0, -1).join('.'),
              display_file_name: fileName,
              name: fileName,
              created_at: res['created_at'],
              progressbar: 0,
              id: res['id'],
              delete_upload_path: res['upload_path'],
            });
            this.saveFileAfterS3UrlCrete(res, file, res.id, this.attachedFiles.length - 1);
          }
        };
        worker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateCreatePresignedUrl(data));
      }
    });
  }
  async saveFileAfterS3UrlCrete(res, file, id, index) {
    let data = {
      file: file,
      token: null,
      url: null,
      fileType: null,
    };

    const xhr = new XMLHttpRequest();
    xhr.upload.onprogress = (progEvent: ProgressEvent) => {
      if (progEvent.lengthComputable) {
        try {
          const uploadedSoFar = (progEvent.loaded / progEvent.total) * 100;

          this.attachedFiles.forEach((element, currentIndex) => {
            if (currentIndex == index) {
              element.progressbar = uploadedSoFar;
            }
          });
          this.cd.detectChanges();
        } catch (error) {
          console.error('error', error);
        }
      }
    };
    xhr.open('PUT', res['upload_url'], true);
    xhr.setRequestHeader('Content-Type', file.type);
    xhr.send(file);
    xhr.onload = () => {
      if (xhr.readyState === xhr.DONE) {
        this.updateFileStatus({ id: id }, index);
      }
    };

    // this.createFileAfterS3UrlCrete(data, res['upload_url'], file.type, file, id, index);
  }
  generateDataKeyPairFileStatus(security_key: any): unknown {
    throw new Error('Method not implemented.');
  }

  generatecreateFileAfterS3UrlCrete(data: any): unknown {
    throw new Error('Method not implemented.');
  }

  generateCreatePresignedUrl(security_key: any): unknown {
    throw new Error('Method not implemented.');
  }

  async updateFileStatus(data, index) {
    const id = data.id;
    let currenReminder = this.reminderList[this.currentStep];
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        const workerId = `status-update-${Date.now()}-${Math.random()}`;
        const worker = new Worker(new URL('./upload-status-update.worker', import.meta.url), { type: 'module' });
        this.activeWorkers.set(workerId, worker);

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        data.url = `${environment.apiUrl}/api/vault/form-upload-file`;
        data.vault_user_form_reminder_id = currenReminder.id;
        worker.onmessage = ({ data }) => {
          //return security key generated by worker process

          // Terminate and cleanup worker
          worker.terminate();
          this.activeWorkers.delete(workerId);

          resolve(data);

          let vault_user_form_reminder_id = this.reminderList[this.currentStep].id;
          this.subscription.add(
            this._inboxService.attachFileToReminder(vault_user_form_reminder_id).subscribe((res) => {
              if (res) {
                let findIndex = res.findIndex((x) => x.id == data.data.data.id);

                this.attachedFiles.forEach((element, index) => {
                  if (element.id == data.data.data.id) {
                    this.attachedFiles[index] = {
                      ...res[findIndex],
                      status: 'Done',
                      selected: false,
                    };
                  }
                });
                // let attachedIndex = this.attachedFiles.findIndex((x) => x.id == data.data.data.id);
                // this.attachedFiles[index] = {
                //   ...res[findIndex],
                //   status: 'Done',
                //   selected: false,
                // };
                // console.log('index', index, findIndex, attachedIndex);
              }

              this.cd.detectChanges();
            })
          );

          this.cd.detectChanges();
        };
        worker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateDataKeyPairFileStatus(data));
      }
    });
  }
  renameFolder(folder, i) {
    let file_name_without_extesion =
      folder.file_name.split('.').slice(0, -1).length == 0 ? folder.file_name : folder.file_name.split('.').slice(0, -1).join('.');
    const dialogRef = this.dialog.open(AddSubfolderComponent, {
      width: '400px',
      maxWidth: this.screenWidth < 480 ? '90vw' : '80vw',
      data: {
        title: 'Rename Attachment',
        buttonName: 'Rename',
        currentFolderName: file_name_without_extesion,
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((Resultdata) => {
        if (Resultdata && Resultdata.confirmation) {
          const extension =
            this.files[i].file_name.substring(this.files[i].file_name.lastIndexOf('.') + 1, this.files[i].file_name.length) ||
            this.files[i].file_name;
          const data = {
            custom_folder_name: Resultdata.subfolderName + '.' + extension,
            id: this.files[i]['id'],
          };
          this.files[i].file_name = Resultdata.subfolderName + '.' + extension;
          this.subscription.add(
            this._inboxService.updateInboxAttachmentFileName(data).subscribe((res) => {
              this.files[i].display_file_name = this.files[i].file_name_without_extesion + '.' + extension;

              // this.toastr.success(`${Resultdata.subfolderName}.${extension} uploaded`);
              this.cd.detectChanges();
            })
          );
        }
      })
    );
  }
  toggleChecklist(event, index) {
    if (event.source.checked) {
      this.files[index].selected = true;
    } else if (!event.source.checked) {
      this.files[index].selected = false;
    }

    this.selectedFiles = this.files.filter((x) => x.selected).length;
    this.cd.detectChanges();
  }

  previousReminder() {
    if (this.currentStep == 0) {
    } else {
      this.currentStep = this.currentStep - 1;
      if (this.currentStep >= this.reminderList.length) {
        this.currentStep = this.reminderList.length - 1;
      }
      this.getAttcahedFileWithReminder();
    }
  }
  submitForm() {
    this.showStepTwo = true;
    this.cd.detectChanges();
    try {
      this.JsonDataExtractedData = {};
      this.childComponent.passJsonData(this.JsonDataExtractedData);
    } catch (error) {
      this.JsonDataExtractedData = {};
    }
    this.cd.detectChanges();
    this.saveForm();

    // this.subscription.add(
    //   this._dataExtractionService.dataExtractionForm(this.currentFormId).subscribe((res) => {
    //     this.showStepTwo = true;
    //     this.cd.detectChanges();
    //     if (res?.data == null) {
    //       this.showStepTwo = true;
    //       try {
    //         this.JsonDataExtractedData = {};
    //         this.childComponent.passJsonData(this.JsonDataExtractedData);
    //       } catch (error) {
    //         this.JsonDataExtractedData = {};
    //       }
    //       this.cd.detectChanges();
    //       this.saveForm();
    //     } else {
    //       this.cd.detectChanges();
    //       this.getReportStatusByFormId();
    //     }
    //   })
    // );
  }
  async saveForm() {
    const data = this.childComponent.documentForm.value;
    this.Form1 = this.childComponent.Form1;
    const obj = {
      dynamicFieldsForm: data['dynamicFieldsForm'][0],
      beneFicaryForm: [],
      showNotes: data['showNotes'],
    };

    this.saveFormDataToDB(obj);
  }
  async dragged(event) {
    this.folderList = [];
    const items = event.dataTransfer.items;
    const fileLists = event.dataTransfer.files;
    this.dragged_data = {
      items,
      fileLists,
      folderList: this.folderList,
    };
    this.cd.detectChanges();
    for (let i = 0; i < items.length; i++) {
      let item = items[i].webkitGetAsEntry();
      let fileList = fileLists[i];
      item.size = fileList.size;
      item.type = fileList.type;
      item.completed = false;
      if (item) {
        this.scanAndLogFiles(item);
      }
    }
  }
  async scanAndLogFiles(item) {
    // const newFile = item.event.dataTransfer.files;
    let newElt = item;

    if (item.isDirectory) {
      const promise = [];
      let directoryReader = item.createReader();
      directoryReader.readEntries((entries) => {
        entries.forEach(async (entry) => {
          try {
            // this.readFile(entry, null, null)
          } catch (error) {}

          this.scanAndLogFiles(entry);
        });
      });
    }

    if (item.isDirectory) {
      newElt.originalFile = undefined;
      this.dragged_data.folderList.push(newElt);
    } else {
      item.file((file) => {
        this.uploadDocument(file, file.name);
      });
    }
  }

  saveFormDataToDB(obj) {
    let request = {
      user_id: this.securityStateObject.userId,
      user_pk: this.securityStateObject.public_key,
      form_data: obj,
      notes: '',
      physical_location: '',
    };
    request['id'] = this.currentFormId;
    if (this.Form1 != null && this.Form1.length != 0) {
      const multiDropMainStack = this.Form1[0]['singleFieldForm'].filter((x) => x.type == 'MultiPleDropDown');
      let multidropDownFomllist = [];
      multiDropMainStack.forEach((element) => {
        if (element && element['data']) {
          element['data'].forEach((childelement) => {
            if (childelement && childelement['template']) {
              multidropDownFomllist = multidropDownFomllist.concat(childelement['template']);
            }
          });
        }
      });
      for (let key of Object.keys(request['form_data']['dynamicFieldsForm'])) {
        const originalData = request['form_data']['dynamicFieldsForm'][key];

        const tempIndex = this.Form1[0]['singleFieldForm'].findIndex((x) => x.formControlName == key);
        if (tempIndex != -1) {
          const currnetTmplateObj = this.Form1[0]['singleFieldForm'][tempIndex];

          if (currnetTmplateObj['type'] == 'date') {
            if (originalData == '' || originalData == null || originalData == undefined) {
            } else {
              const date = new Date(request['form_data']['dynamicFieldsForm'][key]);
              if (Object.prototype.toString.call(date) === '[object Date]') {
                // it is a date
                if (isNaN(date.getTime())) {
                  // d.valueOf() could also work
                  // date is not valid
                } else {
                  const neddddDatae = date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
                  request['form_data']['dynamicFieldsForm'][key] = neddddDatae.toString();
                }
              } else {
                // not a date
              }
            }
          }
        } else {
          const CtempIndex = multidropDownFomllist.findIndex((x) => x.formControlName == key);
          if (CtempIndex != -1) {
            const currnetTmplateObj = multidropDownFomllist[CtempIndex];
            if (currnetTmplateObj['type'] == 'date') {
              if (originalData == '' || originalData == null || originalData == undefined) {
              } else {
                const date = new Date(request['form_data']['dynamicFieldsForm'][key]);
                if (Object.prototype.toString.call(date) === '[object Date]') {
                  // it is a date
                  if (isNaN(date.getTime())) {
                    // d.valueOf() could also work
                    // date is not valid
                  } else {
                    const neddddDatae = date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
                    request['form_data']['dynamicFieldsForm'][key] = neddddDatae.toString();
                  }
                } else {
                  // not a date
                }
              }
            }
          }
        }
      }

      let beneFicaryFormListStack = [];
      this.Form1[0]['multiFieldForm'].forEach((element) => {
        beneFicaryFormListStack = beneFicaryFormListStack.concat(element['template']);
      });
      request['form_data']['beneFicaryForm'].forEach((element, outerindex) => {
        Object.keys(element).forEach((Outerelementkey) => {
          request['form_data']['beneFicaryForm'][outerindex][Outerelementkey].forEach((element, inneIndex) => {
            for (let innerKey of Object.keys(element)) {
              const tempIndex = beneFicaryFormListStack.findIndex((x) => x.formControlName == innerKey);
              if (tempIndex != -1) {
                const currnetTmplateObj = beneFicaryFormListStack[tempIndex];
                if (currnetTmplateObj['type'] == 'date') {
                  const originalData = request['form_data']['beneFicaryForm'][outerindex][Outerelementkey][inneIndex][innerKey];
                  if (originalData == '' || originalData == null || originalData == undefined) {
                  } else {
                    const date = new Date(request['form_data']['beneFicaryForm'][outerindex][Outerelementkey][inneIndex][innerKey]);

                    if (Object.prototype.toString.call(date) === '[object Date]') {
                      // it is a date
                      if (isNaN(date.getTime())) {
                        // d.valueOf() could also work
                        // date is not valid
                      } else {
                        const neddddDatae = date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
                        request['form_data']['beneFicaryForm'][outerindex][Outerelementkey][inneIndex][innerKey] = neddddDatae.toString();
                      }
                    } else {
                      // not a date
                    }
                  }
                }
              }
            }
          });
        });
      });
    } else {
      // delete request['form_data'];
      // delete request['vault_form_id'];
    }

    let sk_value = null;
    // if (this.mode == 'edit') {
    request['security_key'] = null;
    this.subscription.add(
      this.documentService.updateFormTampletData(request, undefined, undefined, undefined, false, undefined, true).subscribe((res) => {
        this.individualLocationNextStep.emit({
          Status_change: true,
        });
      })
    );
  }
  feelData() {
    this.Form1.forEach((element) => {
      // this.childComponent.documentForm.
    });
  }

  getReportStatusByFormId() {
    this.subscription.add(
      this._dataExtractionService.getDataExtractionFormStatus(this.currentFormId).subscribe((res) => {
        if (res.status == 'end') {
          this.showStepTwo = true;
          try {
            this.JsonDataExtractedData = JSON.parse(res.extracted_data);
            this.childComponent.passJsonData(this.JsonDataExtractedData);
          } catch (error) {
            this.JsonDataExtractedData = {};
          }
          this.saveForm();
          this.cd.detectChanges();
        } else {
          setTimeout(() => {
            this.getReportStatusByFormId();
          }, 15000);
        }
      })
    );
  }
  backForm() {
    if (this.showStepTwo) {
      this.showStepTwo = !this.showStepTwo;
    } else {
      this.individualLocationNextStep.emit({ transaction_status: 'backward' });
    }
  }
  deleteAttachmentTOReminder(index, id, display_file_name) {
    const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: { title: 'Delete File', materialIcon: 'delete', text: `Are you sure you want to delete ${display_file_name}?`, proceedTitle: 'Delete' },
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.subscription.add(
            this.documentService.deleteAttachedFileWithReminder(id).subscribe(
              (res) => {
                this.toastr.success(`${display_file_name} deleted`);
                this.getAttcahedFileWithReminder();
                this.getInboxData(this.currentuserId);
                this.cd.detectChanges();
              },
              (error) => {
                this.toastr.error('Error deleting File');
              }
            )
          );
        }
      })
    );
  }
  deleteAttachment(index, id, display_file_name) {
    const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: { title: 'Delete File', materialIcon: 'delete', text: `Are you sure you want to delete ${display_file_name}?`, proceedTitle: 'Delete' },
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.subscription.add(
            this._inboxService.deleteInboxAttachments([id], this.securityStateObject.userId).subscribe(
              (res) => {
                this.getAttcahedFileWithReminder();
                this.getInboxData(this.currentuserId);
                this.toastr.success(`${display_file_name} deleted`);
                this.cd.detectChanges();
              },
              (error) => {
                this.toastr.error('Error deleting File');
              }
            )
          );
        }
      })
    );
  }
  selectAttachment(file) {
    this.is_file_loading = true;
    let attachmentIds: number[] = [file.id];
    this.attachmentAdding(attachmentIds);
  }
  submitReminderForm() {
    this.statusUpdate(true);
  }
  nextReminder() {
    if (this.reminderList.length - 1 == this.currentStep) {
      this.enableContinue = true;
    }
    this.statusUpdate();
  }
  statusUpdate(moveToNext = false) {
    let currenReminder = this.reminderList[this.currentStep];
    let data = {
      id: currenReminder.id,
      status: 'complete',
      onboarding_status: 'donotadd',
    };
    if (this.attachedFiles.length != 0) {
      delete data['onboarding_status'];
    }
    this.subscription.add(
      this.documentService.updateReminder(data).subscribe((res) => {
        if (moveToNext) {
          this.submitForm();
        } else {
          this.currentStep = this.currentStep + 1;
          this.selectDOntAdd = this.reminderList[this.currentStep].onboarding_status == 'donotadd' ? true : false;
          this.getAttcahedFileWithReminder();
        }
      })
    );
  }
  onFileChanged(event, type) {
    this.uploadFile(event);
  }

  attachmentAdding(attachmentIds) {
    let vault_user_form_reminder_id =
      this.reminderList[this.currentStep >= this.reminderList.length ? this.reminderList.length - 1 : this.currentStep].id;
    this.subscription.add(
      this._inboxService.attachToInbox(attachmentIds, this.currentuserId, this.data.vault_user_form_id, vault_user_form_reminder_id).subscribe(
        (result: any) => {
          if (result?.data.status == 'success') {
            this.toastr.success('File attached successfully');
            this.files = [];
            this.getInboxData(this.currentuserId);
            this.selectedFiles = 0;
            this.getAttcahedFileWithReminder();
          }
          this.cd.detectChanges();
        },
        (error: any) => {}
      )
    );
  }
}
